import React from 'react'
import { Text } from '@chakra-ui/react'
import { Link as RouterLink } from 'react-router-dom'

/**
 * Sign-in-wrap notice for Google OAuth — conspicuous, adjacent to the Google button.
 * Continuing with Google constitutes agreement (Meyer v. Uber pattern).
 */
export const OAuthLegalNotice: React.FC = () => (
  <Text fontSize="xs" color="fg.muted" textAlign="center" lineHeight="tall" px={1}>
    By continuing with Google, you confirm you are at least 18 years old and agree to our{' '}
    <RouterLink to="/terms">
      <Text as="span" color="green.600" _dark={{ color: 'green.400' }} textDecoration="underline">
        Terms of Service
      </Text>
    </RouterLink>{' '}
    and{' '}
    <RouterLink to="/privacy">
      <Text as="span" color="green.600" _dark={{ color: 'green.400' }} textDecoration="underline">
        Privacy Policy
      </Text>
    </RouterLink>
    , including how we process genetic data if you upload it.
  </Text>
)

export default OAuthLegalNotice
